<template>
  <div id="main" v-show="mounted">
    <div id="side_left" ref="menuref" :class="{ is_active: isActive }" @click="toggleClickMenu">
      <div class="profile">
        <span :class="['profile_image', {is_image: hasUserImage}]" @click.stop.prevent="redirectToUserProfile">
            {{ userInitials }}
            <img :src="userImage" v-if="hasUserImage">
        </span>
        <a
            :title="'Zobrazit profil' | translate"
            @click.stop.prevent="redirectToUserProfile"
        >{{ fullName }}
        </a>
        <template v-if="clickableOperator">
        <a
            :title="'Zobrazit operátora' | translate"
            class="profile_function"
            @click.stop.prevent="redirectToOperatorProfile"
        >{{ operatorName }}
        </a>
          </template>
        <template v-if="!clickableOperator && !isActive"><span class="profile_function">{{ operatorName }}</span></template>
      </div>

      <div class="floating_navigation">
        <!-- TOGGLE OPERATORS FILTER -->
        <div class="side_tab operator active" v-if="$_loggedUser_canChangeOperator">
          <a
              class="side_tab_link operator_link"
              @click.stop.prevent="toggleOperatorCheckboxes()"
          >
            <translate>Výběr operátora</translate>
          </a>
        </div>

        <!-- NAVIGATION -->
        <navigation
            ref="navigationref1"
            :items="navigationItemsWithOperatorFilter"
            @navigationClick="navigationClick"
            @clickOpen="onClickOpenSubmenu"
        />
        <navigation
            ref="navigationref2"
            :items="navigationItemsIndependent"
            @navigationClick="navigationClick"
            @clickOpen="onClickOpenSubmenu"
        />
        <navigation ref="navigationref3"
            :items="navigationItemsSystemSection"
            @navigationClick="navigationClick"
            @clickOpen="onClickOpenSubmenu"
        ></navigation>
      </div>
    </div>
    <div id="side_right" :class="{ is_active: isActive }">
      <header>
        <button :class="['toggle_menu', { is_active: isActive }]" @click="toggleMenu()">
          <span class="menu" v-translate>menu</span>
        </button>
        <div class="crumb">
          <ul>
            <li><a v-translate>Back-office</a></li>
            <li>{{ getCrumbTitle() }}</li>
          </ul>
        </div>
        <language-select />
        <ul :class="['links', { is_active: isActive }]">
          <logout></logout>
        </ul>
        <div class="app_version" v-if="version">{{version}}</div>
      </header>
      <router-view></router-view>

      <a class="scrollup" id="scrollup" :title="$gettext('Nahoru')" @click.stop="_scrollTop">{{ $gettext('Nahoru') }}</a>
    </div>

    <!-- OPERATORS FILTER CHECKBOXES -->
    <operator-checkboxes
        v-if="$_loggedUser_canChangeOperator"
        ref="operatorcheckboxesref"
        @operatorChanged="onOperatorChange"
    ></operator-checkboxes>

    <!-- INFO / ERROR MESSAGES -->
    <message-box v-show="showMessageBox" :variant="getMessageVariant">{{ printTranslatedMessage() }}</message-box>
  </div>
</template>

<script>
import Navigation from "@/components/Navigation"
import Logout from "@/components/Logout"
import MessageBox from "@/components/common/MessageBox"
import OperatorCheckboxes from "@/components/OperatorCheckboxes"
import LanguageSelect from "@/components/common/LanguageSelect"
import userSettings from "@/components/mixins/user-settings"
import {SET_NAVIGATION_CLOSED, SET_NAVIGATION_OPENED} from "@/store/mutation-types"
import {nextTick} from "vue";

export default {
  name: "home",
  components: {
    OperatorCheckboxes,
    MessageBox,
    Logout,
    Navigation,
    LanguageSelect,
  },
  mixins: [userSettings],
  data: function () {
    return {
      crumbTitle: '',
      showOperatorCheckboxes: false,
      translatedMessages: {
        'Formulář není vyplněn správně.': this.$gettext('Formulář není vyplněn správně.'),
        'Chyba požadavku. Zkontrolujte vyplněné údaje.': this.$gettext('Chyba požadavku. Zkontrolujte vyplněné údaje.'),
        'Služba byla pozastavena, obraťe se na jejího poskytovatele.': this.$gettext('Služba byla pozastavena, obraťte se na jejího poskytovatele.'),
        'Byl jste odhlášen.': this.$gettext('Byl jste odhlášen.'),
        'Požadavek nebo subjekt nebyl nalezen.': this.$gettext('Požadavek nebo subjekt nebyl nalezen.'),
        'Vypršel časový limit pro požadavek. Akci opakujte později.': this.$gettext('Vypršel časový limit pro požadavek. Akci opakujte později.'),
        'Omlouváme se, vyskytla se neznámá chyba.': this.$gettext('Omlouváme se, vyskytla se neznámá chyba.'),
      },
      version: null,
      menuMouseOver: false,
      mounted: false,
      loaded: false,
      isActive: this.$store.getters.isNavigationOpened,
    }
  },
  created(AdminConfigurationService) {
    this.adminConfigurationService = AdminConfigurationService;
    this.adminConfigurationService.getVersion()
        .then((data) => {
          this.version = data.version;
        })
    window.addEventListener("resize", this.onPageSizeChanged);
  },
  destroyed() {
    window.removeEventListener("resize", this.onPageSizeChanged);
  },
  mounted() {
      this._onScroll = this._onScroll.bind(this);
      document.addEventListener('scroll', this._onScroll);
      this.mounted = true;
      nextTick(() => {
        this.loaded = true;
        this._setIsActive();
      });
  },
  beforeDestroy() {
      document.removeEventListener('scroll', this._onScroll);
  },
  computed: {
    navigationItemsWithOperatorFilter() {
      return [
        {
          id: 1,
          title: this.$gettext('Plátci'),
          className: 'platci',
          sectionName: 'billers',
          linkName: 'billers',
          routes: ['billers', 'billerDetail', 'billerNew', 'billerDetailSubscribers', 'billerDetailServices', 'billerDetailDevices'],
        },
        {
          id: 2,
          title: this.$gettext('Odběratelé'),
          className: 'odberatele',
          sectionName: 'subscribers',
          linkName: 'subscribers',
          routes: ['subscribers', 'subscriberDetail', 'subscriberNew'],
        },
        {
          id: 3,
          title: this.$gettext('Zařízení'),
          className: 'zarizeni',
          sectionName: 'devices',
          linkName: 'devices',
          routes: ['devices', 'deviceDetail', 'deviceDashboard', 'deviceActivity', 'deviceChannels', 'deviceChannelGroups', 'deviceMacAddresses', 'deviceDetailBootConfigs'],
        },
        {
          id: 4,
          title: this.$gettext('Správa obsahu'),
          className: 'sprava_obsahu',
          subPages: [
            {
              id: 1,
              title: this.$gettext('Kanály'),
              className: 'kanaly',
              linkName: 'channels',
              sectionName: 'channels',
              routes: ['channels', 'channelDetail'],
            },
            {
              id: 2,
              title: this.$gettext('Balíčky'),
              className: 'balicky',
              linkName: 'packages',
              sectionName: 'packages',
              routes: ['packages', 'packageDetail', 'packageNew'],
            },
            {
              id: 3,
              title: this.$gettext('Služby'),
              className: 'sluzby',
              linkName: 'services',
              sectionName: 'services',
              routes: ['services', 'serviceDetail', 'serviceNew'],
            },
            {
              id: 4,
              title: this.$gettext('Tématické skupiny'),
              className: 'tematicke_skupiny_kanalu',
              linkName: 'thematicGroups',
              sectionName: 'thematicGroups',
              routes: ['thematicGroups', 'thematicGroupDetail', 'thematicGroupNew'],
            },
            {
              id: 5,
              title: this.$gettext('Zdroje obsahu'),
              className: 'zdroje_obsahu',
              linkName: 'contentSources',
              sectionName: 'contentSources',
              routes: ['contentSources', 'contentSourceNew', 'contentSourceDetail', 'contentSourceContentNew'],
            },
            {
              id: 6,
              title: this.$gettext('Údržba zdrojů obsahu'),
              className: 'udrzba_zdroju_obsahu',
              linkName: 'contentSourceMaintenanceWindows',
              sectionName: 'contentSources',
              routes: ['contentSourceMaintenanceWindows', 'contentSourceMaintenanceWindowNew', 'contentSourceMaintenanceWindowsDetail'],
            },
            {
              id: 7,
              title: this.$gettext('Profily streamu'),
              className: 'streamProfiles',
              sectionName: 'streamProfiles',
              linkName: 'streamProfiles',
              routes: ['streamProfiles', 'streamProfileNew', 'streamProfileDetail'],
            },
            {
              id: 8,
              title: this.$gettext('Profily zařízení'),
              className: 'deviceProfiles',
              sectionName: 'deviceProfiles',
              linkName: 'deviceProfiles',
              routes: ['deviceProfiles', 'deviceProfileNew', 'deviceProfileDetail', 'deviceProfileDetailProperties', 'deviceProfileDetailProtocols', 'deviceProfileDetailLinearProtocols',
              'deviceProfileDetailNonLinearProtocols', 'deviceProfileNewProperties', 'deviceProfileNewProtocols', 'deviceProfileNewLinearProtocols', 'deviceProfileNewNonLinearProtocols'],
            },
            {
              id: 12,
              title: this.$gettext('Určení typu zařízení'),
              className: 'deviceTypeEvaluations',
              sectionName: 'deviceTypeEvaluations',
              linkName: 'deviceTypeEvaluations',
              routes: ['deviceTypeEvaluations', 'deviceTypeEvaluationsList', 'deviceTypeEvaluationsTester', 'deviceTypeEvaluationDetail', 'deviceTypeEvaluationNew'],
            },
            {
              id: 9,
              title: this.$gettext('Váhy služeb'),
              className: 'serviceWeightCategories',
              sectionName: 'serviceWeightCategories',
              linkName: 'serviceWeightCategories',
              routes: ['serviceWeightCategories', 'serviceWeightCategoryNew', 'serviceWeightCategoryDetail'],
            },
            {
              id: 10,
              title: this.$gettext('Carousely'),
              className: 'dashboardCarousels',
              sectionName: 'dashboardCarousels',
              linkName: 'dashboardCarousels',
              routes: ['dashboardCarousels', 'dashboardCarouselNew', 'dashboardCarouselDetail'],
            },
            {
              id: 11,
              title: this.$gettext('Blokovaný obsah'),
              className: 'blackoutContents',
              sectionName: 'blackoutContents',
              linkName: 'blackoutContents',
              routes: ['blackoutContents', 'blackoutContentNew', 'blackoutContentDetail'],
            },
          ]
        },
        {
          id: 5,
          title: this.$gettext('Oznámení'),
          className: 'oznameni',
          subPages: [
            {
              id: 1,
              title: this.$gettext('Oznámení'),
              className: 'zpravy',
              linkName: 'messages',
              sectionName: 'messages',
              routes: ['messages', 'messageNew', 'messageDetail', 'messageNewFromTemplate'],
            },
            {
              id: 2,
              title: this.$gettext('Šablony oznámení'),
              className: 'sablony_zprav',
              linkName: 'messageTemplates',
              sectionName: 'messages',
              routes: ['messageTemplates', 'messageTemplateNew', 'messageTemplateDetail'],
            },
            {
              id: 3,
              title: this.$gettext('Marketingová oznámení'),
              className: 'marketingova_oznameni',
              linkName: 'advertisingBanners',
              sectionName: 'advertisingBanners',
              routes: ['advertisingBanners', 'advertisingBannerNew', 'advertisingBannerDetail', 'advertisingBannerDetailSettings', 'advertisingBannerDetailRecipients'],
            },
          ]
        },
        {
          id: 6,
          title: this.$gettext('Videotéka'),
          className: 'filmoteka',
          subPages: [
            {
              id: 1,
              title: this.$gettext('Poskytovatelé videa'),
              className: 'poskytovatele_videa',
              linkName: 'vodProviders',
              sectionName: 'vod',
              routes: ['vodProviders', 'vodProvidersDetail', 'vodProvidersVideos', 'vodProvidersPackages'],
            },
            {
              id: 2,
              title: this.$gettext('Balíčky videí'),
              className: 'balicky_videi',
              linkName: 'vodPackages',
              sectionName: 'vod',
              routes: ['vodPackages', 'vodPackagesDetail', 'vodPackagesVideos'],
            },
            {
              id: 3,
              title: this.$gettext('Videa'),
              className: 'videa',
              linkName: 'vodVideos',
              sectionName: 'vod',
              routes: ['vodVideos', 'vodVideosDetail', 'vodVideosPackages'],
            },
          ]
        },
      ]
    },
    navigationItemsIndependent() {
      return [
        {
          id: 6,
          title: this.$gettext('Administrace'),
          className: 'administrace',
          subPages: [
            {
              id: 0,
              title: this.$gettext('Reporty'),
              className: 'reporty',
              linkName: 'reports',
              sectionName: 'reports',
              routes: ['reports', 'reportsOperator'],
            },
            {
              id: 2,
              title: this.$gettext('Operátoři'),
              className: 'operatori',
              linkName: 'operators',
              sectionName: 'operators',
              routes: ['operators', 'operatorDetail', 'operatorNew', 'operatorUserNew'],
            },
            {
              id: 3,
              title: this.$gettext('Uživatelé'),
              className: 'uzivatele',
              linkName: 'users',
              sectionName: 'users',
              routes: ['users', 'userDetail', 'userNew'],
            },
            {
              id: 4,
              title: this.$gettext('Ke stažení'),
              className: 'ke_stazeni',
              linkName: 'downloads',
              sectionName: 'downloads',
              routes: ['downloads'],
            },
            {
              id: 5,
              title: this.$gettext('Štítky'),
              className: 'stitky',
              linkName: 'tags',
              sectionName: 'tags',
              routes: ['tags'],
            },
            {
              id: 6,
              title: this.$gettext('Operátorské štítky'),
              className: 'operatorske_stitky',
              linkName: 'operatorTags',
              sectionName: 'operatorTags',
              routes: ['operatorTags'],
            },
            {
              id: 7,
              title: this.$gettext('Skupiny oprávnění'),
              className: 'skupiny_roli',
              linkName: 'roleGroups',
              sectionName: 'roleGroups',
              routes: ['roleGroups', 'roleGroupsNew', 'roleGroupsDetail', 'roleGroupsDetailBasicInfo', 'roleGroupsDetailUsers'],
            },
            {
              id: 8,
              title: this.$gettext('Vlastní exporty'),
              className: 'vlastni_exporty',
              linkName: 'customExports',
              sectionName: 'customExports',
              routes: ['customExports', 'customExportDetail'],
            },
          ],

        },
        {
          id: 7,
          title: this.$gettext('Platforma'),
          className: 'platforma',
          subPages: [
            {
              id: 1,
              title: this.$gettext('Kodeky'),
              className: 'codecs',
              linkName: 'codecs',
              sectionName: 'codecs',
              routes: ['codecs'],
            },
            {
              id: 2,
              title: this.$gettext('Protokoly'),
              className: 'protocols',
              linkName: 'protocols',
              sectionName: 'protocols',
              routes: ['protocols', 'protocolNew', 'protocolDetail'],
            },
            {
              id: 3,
              title: this.$gettext('Business modely'),
              className: 'businessModels',
              linkName: 'businessModels',
              sectionName: 'businessModels',
              routes: ['businessModels', 'businessModelsNew', 'businessModelsDetail'],
            },
            {
              id: 4,
              title: this.$gettext('Brandy'),
              className: 'brands',
              linkName: 'brands',
              sectionName: 'brands',
              routes: ['brands', 'brandDetail', 'brandNew'],
            },
            {
              id: 5,
              title: this.$gettext('Typy zařízení'),
              className: 'deviceTypes',
              linkName: 'deviceTypes',
              sectionName: 'deviceTypes',
              routes: ['deviceTypes', 'deviceTypeDetailDescription', 'deviceTypeDetailStreams', 'deviceTypeNewDescription'],
            },
            {
              id: 6,
              title: this.$gettext('Základní konfigurace'),
              className: 'adminConfiguration',
              linkName: 'adminConfiguration',
              sectionName: 'adminConfiguration',
              routes: ['adminConfiguration'],
            },
            {
              id: 7,
              title: this.$gettext('Konfigurace zařízení'),
              className: 'deviceConfigs',
              linkName: 'deviceConfigs',
              sectionName: 'deviceConfigs',
              routes: ['deviceConfigs', 'deviceConfigDetailProperties', 'deviceConfigDetailPlatform', 'deviceConfigDetailDevice', 'deviceConfigDetailPlayer', 'deviceConfigDetailFunctions',
              'deviceConfigNewProperties', 'deviceConfigNewPlatform', 'deviceConfigNewDevice', 'deviceConfigNewPlayer', 'deviceConfigNewFunctions'],
            },
            {
              id: 8,
              title: this.$gettext('Konfigurace bootování'),
              className: 'deviceBootConfigs',
              linkName: 'deviceBootConfigs',
              sectionName: 'deviceBootConfigs',
              routes: ['deviceBootConfigs', 'deviceBootConfigNew', 'deviceBootConfigDetail'],
            },
            {
              id: 9,
              title: this.$gettext('Lokality'),
              className: 'localities',
              linkName: 'localities',
              sectionName: 'localities',
              routes: ['localities', 'localitiesDetail'],
            },
            {
              id: 10,
              title: this.$gettext('Přesměrování aplikací'),
              className: 'versionRedirects',
              linkName: 'versionRedirects',
              sectionName: 'versionRedirects',
              routes: ['versionRedirects', 'versionRedirectNew', 'versionRedirectDetail'],
            },
            {
              id: 11,
              title: this.$gettext('Inicializační proces zařízení'),
              className: 'initialProcessSetup',
              linkName: 'initialProcessSetup',
              sectionName: 'initialProcessSetup',
              routes: ['initialProcessSetup', 'initialProcessSetupNew', 'initialProcessSetupDetail'],
            },
            {
              id: 12,
              title: this.$gettext('Měny'),
              className: 'currencies',
              linkName: 'currencies',
              sectionName: 'currencies',
              routes: ['currencies', 'currenciesDetail'],
            },
          ]
        },
      ]
    },
    navigationItemsSystemSection() {
      return [
        {
          id: 10,
          title: this.$gettext('Údržba'),
          className: 'udrzba',
          subPages: [
            {
              id: 1,
              title: this.$gettext('Optimalizace'),
              className: 'optimization',
              sectionName: 'optimization',
              linkName: 'optimization',
              routes: ['optimization'],
            },
            {
              id: 2,
              title: this.$gettext('Cron'),
              className: 'cron',
              linkName: 'crons',
              sectionName: 'crons',
              routes: ['crons', 'cronDetail'],
            },
            {
              id: 3,
              title: this.$gettext('Správa MAC adres'),
              className: 'registrovane-mac-adresy',
              linkName: 'batchList',
              sectionName: 'registeredMacs',
              routes: ['registeredMacAddressBatches', 'registeredMacAddressBatchDetail','registeredMacAddressBatchNew', 'batchList', 'macAddressList'],
            }
          ]
        },
      ]
    },
    userInitials() {
      let initials = ''
      if (this.fullName) {
        let words = this._.words(this.fullName)
        initials = words[0].charAt(0)
        if (words.length > 1) {
          initials += words[1].charAt(0)
        }
      }
      return this._.toUpper(initials)
    },
    userImage() {
      return 'uploads/user_images/' + this.$store.getters.userImage
    },
    hasUserImage() {
      return Boolean(this.$store.getters.userImage)
          && this.$store.getters.userImage != 'null'
          && this.$store.getters.userImage != undefined
          && this.$store.getters.userImage != 'undefined'
    },
    fullName() {
      return this.$store.getters.getFullName
    },
    operatorName() {
      if (this.$_loggedUser_canChangeOperator) {
        return this.$store.getters.getSelectedOperatorId
            ? this.$store.getters.getSelectedOperatorName
            : this.$gettext('všichni operátoři');
      }else{
        return this.$store.getters.getOperatorName;
      }
    },
    clickableOperator(){
      return this.$_loggedUser_selectedOperatorId && this.$_loggedUser_action_allowed('operators', 'read');
    },
    showMessageBox() {
      return this.$store.getters.hasMessage
    },
    getMessageVariant() {
      return this.$store.getters.getVariant
    },
    translatedMessagesKeys() {
      return this._.keys(this.translatedMessages)
    },
  },
  methods: {
    _setIsActive(){
      let shouldActive = this.$store.getters.isNavigationOpened || this.menuMouseOver;
      this.isActive = this.reverseMenuActive() ? !shouldActive : shouldActive;
    },
    _onScroll() {
        if (window.scrollY > 300) {
            $('.scrollup').addClass('visible');
        } else {
            $('.scrollup').removeClass('visible');
        }
    },
    _scrollTop() {
        $('html, body').animate({
            scrollTop: 0
        }, 600);
    },
    onPageSizeChanged(){
      if(this.isMenuOpened() !== this.$store.getters.isNavigationOpened){
        this._setMenu(!this.isMenuOpened());
        this.onMenuMouseOut();
      }
    },
    onMenuMouseOver(){
      this.menuMouseOver = true;
      this._setIsActive();
    },
    onMenuMouseOut(){
      this.menuMouseOver = false;
      this._setIsActive();
    },
    reverseMenuActive(){
      let element = this.$refs.menuref
      let width = window.innerWidth;
      if(width >= 1024){
        return (element.clientWidth > 80 && !element.classList.contains('is_active'))
            || (element.clientWidth < 260 && element.classList.contains('is_active'))
      }else{
        return (element.clientWidth === 260 && !element.classList.contains('is_active'))
            || (element.clientWidth === 80 && element.classList.contains('is_active'))
      }
    },
    isMenuOpened(){
      return this.$refs.menuref.clientWidth === 260;
    },
    _setMenu(value){
      this.$store.dispatch(value ? SET_NAVIGATION_OPENED: SET_NAVIGATION_CLOSED);
    },
    toggleClickMenu(){
      if(this.isActive){
        this.toggleMenu();
      }
    },
    toggleMenu() {
      this._setMenu(!this.$store.getters.isNavigationOpened);
      this._setIsActive();
    },
    navigationClick(type) {
      let operatorCheckboxes = this.$refs.operatorcheckboxesref;
      if(operatorCheckboxes){
        operatorCheckboxes.hide();
      }
      if(type === 'touch' && window.innerWidth < 1024){
        this.onMenuMouseOut();
        this.toggleMenu();
        this._setIsActive();
      }
      this.closeMenuIfNotActive();
    },
    onClickOpenSubmenu(){
      if(!this.isMenuOpened()){
        this.onMenuMouseOver();
        this.onMenuMouseOver();
      }
    },
    closeMenuIfNotActive(){
      if(this.$refs['navigationref1']) {
        this.$refs['navigationref1'].closeIfNotActive()
      }
      if(this.$refs['navigationref2']) {
        this.$refs['navigationref2'].closeIfNotActive()
      }
      if(this.$refs['navigationref3']) {
        this.$refs['navigationref3'].closeIfNotActive()
      }
    },

    getCrumbTitle() {
      if (this.$route.path.includes('operators')) {
        this.crumbTitle = this.$gettext('Operátoři')
      } else if (this.$route.path.includes('subscribers')) {
        this.crumbTitle = this.$gettext('Odběratelé')
      } else if (this.$route.path.includes('channels')) {
        this.crumbTitle = this.$gettext('Kanály')
      } else if (this.$route.path.includes('packages')) {
        this.crumbTitle = this.$gettext('Balíčky')
      } else if (this.$route.path.includes('users')) {
        this.crumbTitle = this.$gettext('Uživatelé')
      } else if (this.$route.path.includes('roleGroups')) {
        this.crumbTitle = this.$gettext('Skupiny uživatelských oprávnění')
      } else if (this.$route.path.includes('billers')) {
        this.crumbTitle = this.$gettext('Plátci')
      } else if (this.$route.path.includes('services')) {
        this.crumbTitle = this.$gettext('Služby')
      } else if (this.$route.path.includes('downloads')) {
        this.crumbTitle = this.$gettext('Ke stažení')
      } else if (this.$route.path.includes('content-sources')) {
        this.crumbTitle = this.$gettext('Zdroje obsahu')
      } else if (this.$route.path.includes('content-source-maintenance-window')) {
        this.crumbTitle = this.$gettext('Údržba zdrojů obsahu')
      } else if (this.$route.path.includes('reports')) {
        this.crumbTitle = this.$gettext('Reporty')
      } else if (this.$route.path.includes('optimization')) {
        this.crumbTitle = this.$gettext('Optimalizace')
      } else if (this.$route.path.includes('crons')) {
        this.crumbTitle = this.$gettext('Cron')
      } else if (this.$route.path.includes('request-logs')) {
        this.crumbTitle = this.$gettext('Request logy')
      } else if (this.$route.path.includes('error-logs')) {
        this.crumbTitle = this.$gettext('Error logy')
      } else if (this.$route.path.includes('tags')) {
        this.crumbTitle = this.$gettext('Štítky')
      } else if (this.$route.path.includes('message-templates')) {
        this.crumbTitle = this.$gettext('Šablony oznámení')
      } else if (this.$route.path.includes('messages')) {
        this.crumbTitle = this.$gettext('Oznámení')
      } else if (this.$route.path.includes("codecs")) {
        this.crumbTitle = this.$gettext("Kodeky")
      } else if (this.$route.path.includes("protocols")) {
        this.crumbTitle = this.$gettext("Protokoly")
      } else if (this.$route.path.includes("businessModels")) {
        this.crumbTitle = this.$gettext("Business modely")
      } else if (this.$route.path.includes("brands")) {
        this.crumbTitle = this.$gettext("Brandy")
      } else if (this.$route.path.includes("streamProfiles")) {
        this.crumbTitle = this.$gettext("Stream profily")
      } else if (this.$route.path.includes("serviceWeightCategories")) {
        this.crumbTitle = this.$gettext("Váhy služeb")
      } else if (this.$route.path.includes("adminConfiguration")) {
        this.crumbTitle = this.$gettext("Základní konfigurace")
      } else if (this.$route.path.includes("deviceTypes")) {
        this.crumbTitle = this.$gettext("Typy zařízení")
      } else if (this.$route.path.includes("deviceProfiles")) {
        this.crumbTitle = this.$gettext("Profily zařízení")
      } else if (this.$route.path.includes("deviceConfigs")) {
          this.crumbTitle = this.$gettext("Konfigurace zařízení")
      } else if (this.$route.path.includes("localities")){
        this.crumbTitle = this.$gettext("Lokality")
      } else if (this.$route.path.includes("devices")) {
        this.crumbTitle = this.$gettext("Zařízení");
      } else if (this.$route.path.includes("vodProviders")) {
        this.crumbTitle = this.$gettext("Poskytovatelé videa");
      } else if (this.$route.path.includes("vodPackages")) {
        this.crumbTitle = this.$gettext("Video balíčky");
      } else if (this.$route.path.includes("vodVideos")) {
        this.crumbTitle = this.$gettext("Videa");
      } else if (this.$route.path.includes("currencies")) {
        this.crumbTitle = this.$gettext("Měny");
      } else if (this.$route.path.includes("dashboardCarousel")) {
        this.crumbTitle = this.$gettext("Carousely");
      } else if (this.$route.path.includes("registeredMacAddress")) {
        this.crumbTitle = this.$gettext("Registrované MAC adresy");
      } else if (this.$route.path.includes("versionRedirect")) {
        this.crumbTitle = this.$gettext("Přesměrování aplikací");
      } else if (this.$route.path.includes("advertisingBanner")) {
        this.crumbTitle = this.$gettext("Marketingová oznámení");
      } else if (this.$route.path.includes("thematicGroup")) {
        this.crumbTitle = this.$gettext("Tématické skupiny kanálů");
      } else if (this.$route.path.includes("blackoutContent")) {
        this.crumbTitle = this.$gettext("Blokovaný obsah");
      } else if (this.$route.path.includes("deviceBootConfigs")) {
        this.crumbTitle = this.$gettext("Konfigurace bootování");
      }
      return this.crumbTitle
    },
    redirectToUserProfile() {
      this.$router.push({name: 'userDetail', params: {id: this.$_loggedUser_userId}})
    },
    redirectToOperatorProfile() {
      this.$router.push({name: 'myOperatorDetail', params: {id: this.$store.getters.getSelectedOperatorId ? this.$store.getters.getSelectedOperatorId : this.$_loggedUser_operatorId}})
    },
    printTranslatedMessage() {
      const message = this.$store.getters.getMessage
      if (this.translatedMessagesKeys.includes(message)) {
        return this.translatedMessages[message]
      } else {
        return message
      }
    },
    toggleOperatorCheckboxes(){
      let operatorCheckboxes = this.$refs.operatorcheckboxesref;
      if(operatorCheckboxes){
        operatorCheckboxes.toggleShow();
      }
    },
    onOperatorChange(){
      this.$router.go('/');
    },
    checkAccessRights(){
      let always_allowed_route_names = ['myOperatorDetail'];
      const sectionName = this.$route.meta.sectionName;
      const action = this.$route.meta.action ? this.$route.meta.action : 'read';
      if((!this.$_loggedUser_action_allowed(sectionName, action)
        && this.$route.meta.hasOwnProperty('requiresAuth')
        && this.$route.meta.requiresAuth
          && !always_allowed_route_names.includes(this.$route.name)
      ))
      {
        console.error('You don\'t have access rights. SectionName: '+sectionName+', action: '+action );
        this.$router.push('access-denied');
      }
    }
  },
  watch: {
    $route(){
      this.checkAccessRights();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue